import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  className?: string;
  loading?: boolean;
  small?: boolean;
}

const IconicField = styled(({ className, loading, small }: IProps) => (
  <div className={className}>
    {loading && (
      <FontAwesomeIcon icon="spinner" size={small ? "2x" : "3x"} spin />
    )}
  </div>
))`
  position: absolute;
  //z-index: -1;
  width: 100%;
  height: 100%;
  top: -2px;
  left: 1rem;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
  color: ${theme.color.primary};
`;

export default IconicField;



// WEBPACK FOOTER //
// ./src/components/common/IconicField.tsx